import "jquery/dist/jquery.slim.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import {enableProdMode} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import "./polyfills";
import {AppModule} from "./app";
import {environment} from "./environments/environment";

if (environment.PRODUCTION) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
